// src/videoData.js

// Import images
import v1thumbnail from '../../assets/v1thumbnail.png';
import v2thumbnail from "../../assets/v2thumbnail.JPG"

// Export video data as a JavaScript object
const videoData = [
  {
    imageSrc: v1thumbnail,
    title: "The legacy of B.K. Hrangkhawl Part 1- The Beginning",
    duration: "58:69 mins",
    videoUrl: "https://youtu.be/oLFnATDbvXI"
  },
  {
    imageSrc: v2thumbnail,
    title: "The Legacy of B.K. Hrangkhawl Part 2 (Unavailable)",
    duration: "52:5 mins",
    videoUrl: null
  }
  
];

export default videoData;
